import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.ATF, StringBundle.BTF],
  strings: [
    'DV_MWTW_TITLE',
    'DV_MWTW_TITLE_MAIN'
  ] as const,
}
